import axios from "axios";
import { DesiredType } from "./DesiredType.types";
import { environment } from "../../environments/environment";
const API_BASE_NAME = `${environment.apiBaseUrl}`;



const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

export const createDesired = async (payload: any) => {
  try {
    const response = await axios.post(
      `${API_BASE_NAME}/metal/add`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          ...authHeader().headers,
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Error creating desired:", error.response?.data || error.message);
    throw error;
  }
};

export const getDesiredById = async (id: number): Promise<DesiredType> => {
  // Try dedicated endpoint; fallback to list if not available.
  try {
    const res = await axios.get(`${API_BASE_NAME}/metal/${id}`, authHeader());
    const data = res.data?.data || res.data;
    return {
      id: data.id,
      name: data.name,
      description: data.description,
      isActive: Boolean(data.isActive ?? data.status === "active"),
    };
  } catch (err) {
    // fallback to list
    const list = await getAllDesired();
    const found = list.data?.find((item: any) => Number(item.id) === id);
    if (!found) throw err;
    return {
      id: found.id,
      name: found.name,
      description: found.description,
      isActive: Boolean(found.isActive ?? found.status === "active"),
    };
  }
};

export const updateDesiredApi = async (
  id: number,
  payload: { name: string; description: string }
) => {
  return axios.put(`${API_BASE_NAME}/metal/update/${id}`, payload, {
    headers: {
      "Content-Type": "application/json",
      ...authHeader().headers,
    },
  });
};

export const deleteDesiredApi = async (id: number) => {
  return axios.delete(`${API_BASE_NAME}/metal/delete/${id}`, authHeader());
};

export const getAllDesired = async (): Promise<{ data: any[] }> => {
    const res = await axios.get(`${API_BASE_NAME}/metal/list`);
    return res.data;
};

export const getAllDesireds = async (): Promise<{ data: any[] }> => {
    const res = await axios.get(`${API_BASE_NAME}/metal/Activelist`);
    return res.data;
};



export const updateMetalStatusApi = async (id: number): Promise<void> => {
  await axios.put(`${API_BASE_NAME}/metal/status/${id}`);
};

export const deleteFaqApi = async (faq_id: number): Promise<void> => {
    await axios.delete(`${API_BASE_NAME}/Delete_Faq/${faq_id}`, {
        data: { status: "INACTIVE" }
    });
};
